import { useState, useEffect } from "react";
import "./styles.css";

function App() {
  const [data, setData] = useState({
    fullName: "",
    email: "",
    maritalStatus: "",
    genre: "",
  });

  const handleSubmit = (e) => {
    const { name, value } = e.target;

    setData((prev) => {
      const newData = { ...prev, [name]: value };

      return newData;
    });
  };

  function validateEmail(email) {
    var mailformat =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (email.match(mailformat)) {
      return true;
    } else {
      return false;
    }
  }

  const calculateProgress = () => {
    let value = 0;
    let amountToAdd = 25;
    const nome = data.fullName.split(" ");

    if (nome.length > 1) {
      if (nome[1].length > 2) {
        value += amountToAdd;
      }
    }

    if (validateEmail(data.email)) value += amountToAdd;
    if (data.maritalStatus) value += amountToAdd;
    if (data.genre) value += amountToAdd;

    return value;
  };

  const handleClick = () => {
    alert("You are successfully logged in.");
    setData({
      fullName: "",
      email: "",
      maritalStatus: "",
      genre: "",
    });
  };

  return (
    <div className="App">
      <h1>Newsletter</h1>

      <main>
        <div className="bar-container">
          <div
            className="bar"
            style={{ width: `${calculateProgress()}%` }}
          ></div>
        </div>
        <div className="form-group">
          <label htmlFor="">Full name</label>

          <input
            name="fullName"
            value={data.fullName}
            onChange={handleSubmit}
          />
        </div>
        <div className="form-group">
          <label htmlFor="">Email adress</label>
          <input name={"email"} value={data.email} onChange={handleSubmit} />
        </div>
        <div className="form-group">
          <label htmlFor="">Civil status</label>
          <select
            name="maritalStatus"
            value={data.maritalStatus}
            onChange={handleSubmit}
            required
          >
            <option value="">- Select...</option>
            <option value="solteiro">Single</option>
            <option value="casado">Married</option>
            <option value="divorciado">Divorced</option>
          </select>
        </div>
        <div className="form-group">
          <label htmlFor="">Genre</label>
          <div className="radios-container">
            <span>
              <input
                type="radio"
                name="genre"
                value="masculino"
                onChange={handleSubmit}
                checked={data.genre === "masculino"}
              />{" "}
              Male
            </span>
            <span>
              <input
                type="radio"
                name="genre"
                value="feminino"
                onChange={handleSubmit}
                checked={data.genre === "feminino"}
              />{" "}
              Female
            </span>
          </div>
        </div>
        <button onClick={handleClick} disabled={calculateProgress() !== 100}>
          Sign up
        </button>
      </main>
    </div>
  );
}

export default App;
